import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import MainLayout from './layouts/MainLayout';
import SubmitIncident from './pages/SubmitIncident';
import IncidentList from './pages/IncidentList';
import IncidentDetail from './pages/IncidentDetail';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import CompanyManagement from './pages/CompanyManagement';
import UserManagement from './pages/UserManagement';
import MyCompany from './pages/MyCompany';
import CreateCompanyAdmin from './pages/CreateCompanyAdmin';
import CompanyDetail from './pages/CompanyDetail';
import { LanguageProvider } from './context/LanguageContext';
import { AuthProvider } from './context/AuthContext';
import { CompanyProvider } from './context/CompanyContext';
import { APP_ROUTES } from './routes';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import PrivateRoute from './components/common/PrivateRoute';

const queryClient = new QueryClient();

export default function App() {
    return (
        <QueryClientProvider client={queryClient}>
            <LanguageProvider>
                <AuthProvider>
                    <CompanyProvider>
                        <Toaster position="top-right" />
                        <Router>
                            <Routes>
                                <Route path="/" element={<Login />} />
                                <Route path={APP_ROUTES.LOGIN} element={<Login />} />

                                <Route element={<PrivateRoute />}>
                                    <Route element={<MainLayout />}>
                                        <Route path={APP_ROUTES.DASHBOARD} element={<Dashboard />} />
                                        <Route path={APP_ROUTES.SUBMIT_INCIDENT} element={<SubmitIncident />} />
                                        <Route path={APP_ROUTES.INCIDENT_LIST} element={<IncidentList />} />
                                        <Route path={APP_ROUTES.INCIDENT_DETAIL} element={<IncidentDetail />} />
                                        <Route path={APP_ROUTES.COMPANY} element={<CompanyManagement />} />
                                        <Route path={APP_ROUTES.COMPANY_DETAIL} element={<CompanyDetail />} />
                                        <Route path={APP_ROUTES.USERS} element={<UserManagement />} />
                                        <Route path={APP_ROUTES.MY_COMPANY} element={<MyCompany />} />
                                        <Route path={APP_ROUTES.CREATE_COMPANY_ADMIN} element={<CreateCompanyAdmin />} />
                                        {/* For now, suggestions can just redirect to logs or a placeholder */}
                                        <Route
                                            path={APP_ROUTES.SUGGESTIONS}
                                            element={<Navigate to={APP_ROUTES.INCIDENT_LIST} replace />}
                                        />
                                    </Route>
                                </Route>

                                <Route path="*" element={<Navigate to="/" replace />} />
                            </Routes>
                        </Router>
                    </CompanyProvider>
                </AuthProvider>
            </LanguageProvider>
        </QueryClientProvider>
    );
}
